import type { AssignmentLine } from 'src/api/rpc/hooks/procurement/useReplenishmentSuggestions';

/** Per-cart shift-select state survives BuyerBoardLayout panel remounts (line pane open). */

export type AssignmentLineHighlightSession = {
  anchorId: string | null;
  highlightedIds: Set<string>;
  /** Latest assignment-board lines for bulk Planning Details overrides. */
  linesBySuggestionId: Map<string, AssignmentLine>;
};

const sessions = new Map<string, AssignmentLineHighlightSession>();

export function assignmentLineHighlightSession(
  cartKey: string,
): AssignmentLineHighlightSession {
  let session = sessions.get(cartKey);
  if (session === undefined) {
    session = {
      anchorId: null,
      highlightedIds: new Set(),
      linesBySuggestionId: new Map(),
    };
    sessions.set(cartKey, session);
  }
  return session;
}
